var _circle, _line, _line2, _polyline, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterprisePlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    fill: "#f8f9fa",
    stroke: "#e9ecef",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 75,
    x2: 80,
    y2: 75,
    stroke: "#6c757d",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 75,
    x2: 20,
    y2: 25,
    stroke: "#6c757d",
    strokeWidth: 2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "20,70 30,60 40,50 50,40 60,30 70,25 80,20",
    fill: "none",
    stroke: "#28a745",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 70,
    r: 2,
    fill: "#28a745"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 60,
    r: 2,
    fill: "#28a745"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50,
    r: 2,
    fill: "#28a745"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 2,
    fill: "#28a745"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 30,
    r: 2,
    fill: "#28a745"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 25,
    r: 2,
    fill: "#28a745"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 20,
    r: 2,
    fill: "#28a745"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 75,
    x2: 25,
    y2: 25,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 75,
    x2: 35,
    y2: 25,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 75,
    x2: 45,
    y2: 25,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 75,
    x2: 55,
    y2: 25,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 75,
    x2: 65,
    y2: 25,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 75,
    x2: 75,
    y2: 25,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 65,
    x2: 80,
    y2: 65,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 55,
    x2: 80,
    y2: 55,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 45,
    x2: 80,
    y2: 45,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 35,
    x2: 80,
    y2: 35,
    stroke: "#e9ecef",
    strokeWidth: 1,
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlatform);
export default __webpack_public_path__ + "static/media/EnterprisePlatform.a33b96c27b4ed663c189bf43f51c84a3.svg";
export { ForwardRef as ReactComponent };